import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_4 = {
  filter: "from",
  sort: "from"
}
const _hoisted_5 = {
  filter: "to",
  sort: "to"
}
const _hoisted_6 = {
  filter: "distanceKM",
  filterType: "number",
  sort: "distanceKM"
}
const _hoisted_7 = {
  filter: "transportType",
  sort: "transportType"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { colspan: "10" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Transport Configuration",
        text: "Transport Configuration",
        class: "mb-0"
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editConfiguration(null)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add Configuration",
            text: "Add Configuration"
          })
        ]),
        _createElementVNode("button", {
          class: "btn btn-tertiary ms-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadExcelModal()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Upload Excel",
            text: "Upload Excel"
          })
        ])
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.items
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "From",
                      text: "From"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "To",
                      text: "To"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Distance (KM)",
                      text: "Distance (KM)"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Transport Type",
                      text: "Transport Type"
                    })
                  ]),
                  _hoisted_8
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      _createElementVNode("td", _hoisted_10, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.TransportDistanceCalculationVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.from), 1),
                    _createElementVNode("td", null, _toDisplayString(item.to), 1),
                    _createElementVNode("td", null, _toDisplayString(item.distanceKM), 1),
                    _createElementVNode("td", null, _toDisplayString(item.transportType), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.editConfiguration(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Edit",
                          text: "Edit"
                        })
                      ], 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}